import { Button } from '@/components/Button'
import { Dropdown, DropdownDivider, DropdownTitle } from '@/components/Dropdown'
import { RadioGroup, RadioItem } from '@/components/RadioGroup'
import { type JobPeriodFilterOption } from '@/features/jobs/list/job-period-filter-option'
import { type JobSearchScope } from '@/features/jobs/list/SearchableJobStore'

export interface JobFilterViewHeadingProps {
  showSearchScopeFilter: boolean
  scope: JobSearchScope
  jobPeriodOption: JobPeriodFilterOption
  onScopeChange: (scope: JobSearchScope) => unknown
  onJobPeriodChange: (period: JobPeriodFilterOption) => unknown
}

export function JobFilterViewHeading({
  showSearchScopeFilter,
  scope,
  jobPeriodOption,
  onScopeChange,
  onJobPeriodChange,
}: JobFilterViewHeadingProps) {
  return (
    <Dropdown
      autoDismiss
      width="small"
      button={<Button label="Filter View" iconRight="dropdown" />}
    >
      {showSearchScopeFilter && (
        <>
          <DropdownTitle>View</DropdownTitle>
          <RadioGroup>
            <RadioItem
              selected={scope === 'All'}
              onChange={() => onScopeChange('All')}
            >
              All jobs
            </RadioItem>
            <RadioItem
              selected={scope === 'Mine'}
              onChange={() => onScopeChange('Mine')}
            >
              My jobs
            </RadioItem>
          </RadioGroup>
          <DropdownDivider />
        </>
      )}
      <DropdownTitle>Filter by period</DropdownTitle>
      <RadioGroup>
        <RadioItem
          selected={jobPeriodOption === 'All'}
          onChange={() => onJobPeriodChange('All')}
        >
          All jobs
        </RadioItem>
        <RadioItem
          selected={jobPeriodOption === 'Current'}
          onChange={() => onJobPeriodChange('Current')}
        >
          Current jobs
        </RadioItem>
        <RadioItem
          selected={jobPeriodOption === 'Old'}
          onChange={() => onJobPeriodChange('Old')}
        >
          Old jobs
        </RadioItem>
      </RadioGroup>
    </Dropdown>
  )
}
